import type { SVGProps } from 'react';

import { strokeStyle } from '../Illustration.css';
import { useIllustrationShades } from '../Illustration.hooks';

type Props = SVGProps<SVGSVGElement> & {
  strokeWidth: number;
};

export const Calculator = ({ strokeWidth, ...delegated }: Props) => {
  const shades = useIllustrationShades();

  return (
    <svg fill="none" height="117" viewBox="0 0 93 117" width="93" xmlns="http://www.w3.org/2000/svg" {...delegated}>
      <path
        className={strokeStyle}
        d="M88.94 78.56c-1.11-.53-2.47-.88-3.57-.02-1.6 1.25-2.3 6.49-1.06 9.56-1.74 2.9-3.98 5.87-6.74 8.02-5 13.23-17.46 17.63-26.59 15.1a5.1 5.1 0 0 0-4.34.76c-6.98 4.96-24.51 4.56-29.06-3.31 3.66.4 4.3-8.53 8.01-12.17l38.48-6.3a7.1 7.1 0 0 0 5.86-8.16l.95-10.2a13 13 0 0 1 9.92-4.1c7.83.3 9.29 7.26 8.14 10.82Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M88.94 78.56q-.09.28-.21.55c-.72 1.59-2.16 5.23-4.43 8.99-1.23-3.08-.54-8.32 1.06-9.56 1.09-.86 2.46-.5 3.57.02Z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="m65.18 23.98 9.23 60.67c.58 3.83-1.92 7.4-5.6 7.95l-38.34 5.83q-.42.07-.82.06a6.5 6.5 0 0 1-3.07-.67l-.1-.06a7.1 7.1 0 0 1-3.7-5.25l-9.24-60.68c-.57-3.81 1.93-7.36 5.59-7.92l38.34-5.83a6.5 6.5 0 0 1 4.76 1.12 7 7 0 0 1 2.95 4.78Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="m57.8 28.57-35.85 5.45 1.25 8.2 35.85-5.46z" fill={shades.primary.dark} strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="m57.8 28.57-35.85 5.45 1.25 8.2-1.34-.98-1.24-8.2 35.85-5.45z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        d="m28.45 38.52.6.52-.5.6-.74-.65q-.22.1-.46.14a1.7 1.7 0 0 1-1.97-1.42 1.7 1.7 0 0 1 1.46-1.94c.97-.16 1.82.48 1.95 1.42q.1.77-.35 1.33Zm-1.21-.15a.9.9 0 0 0 .76-1.06.9.9 0 0 0-1.04-.79.9.9 0 0 0-.76 1.06.9.9 0 0 0 1.04.79Z"
        fill={shades.white}
      />
      <path
        d="M32.24 36.78c.15 1-.34 1.65-1.27 1.8-.92.13-1.58-.35-1.74-1.34l-.26-1.73.8-.11.27 1.73c.07.5.4.76.81.7s.65-.41.58-.9l-.27-1.75.81-.11z"
        fill={shades.white}
      />
      <path d="m33.29 34.85.5 3.24-.81.12-.5-3.24z" fill={shades.white} />
      <path
        d="m36.58 36.3.82-.14c.02.86-.53 1.51-1.41 1.65a1.67 1.67 0 0 1-1.97-1.42c-.15-.98.49-1.78 1.46-1.94.88-.14 1.6.34 1.83 1.16l-.83.12a.77.77 0 0 0-.9-.53c-.52.09-.83.52-.74 1.06s.5.87 1.03.8a.77.77 0 0 0 .7-.78z"
        fill={shades.white}
      />
      <path d="m39.2 36.03-.4.62.1.66-.8.12-.5-3.23.8-.12.23 1.48 1.07-1.68.95-.14-1.02 1.6 1.61 1.61-1 .16z" fill={shades.white} />
      <path d="m46.25 36.18-.8.12-.25-1.62-.55 1.22-.45.07-.89-1 .26 1.62-.8.12-.5-3.23.6-.09 1.4 1.55.88-1.9.6-.09z" fill={shades.white} />
      <path
        d="m48.94 35.21-1.36.21-.13.59-.85.13.88-3.45.77-.11 1.85 3.02-.85.12-.3-.52zm-.36-.63-.59-1.02-.26 1.15z"
        fill={shades.white}
      />
      <path d="m52.22 32.7-1.03.16.38 2.5-.8.13-.38-2.51-1.04.15-.1-.71 2.85-.43z" fill={shades.white} />
      <path d="m55.38 31.5.5 3.23-.8.12-.19-1.21-1.32.2.19 1.2-.8.13-.5-3.24.8-.11.2 1.3 1.32-.2-.2-1.3z" fill={shades.white} />
      <path className={strokeStyle} d="m34.16 51.36 1.25 8.2-8.2 1.25-1.44-1.66-1.24-8.2 8.2-1.24z" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="m32.73 49.71-8.2 1.25 1.24 8.2 8.2-1.25z" fill={shades.white} strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="m34.16 51.36 1.25 8.2-8.2 1.25-1.44-1.66 8.2-1.24-1.24-8.2z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="m46.55 47.6-8.2 1.25 1.25 8.2 8.2-1.25z" fill={shades.white} strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="m47.99 49.26 1.25 8.2-8.2 1.25-1.44-1.66 8.2-1.24-1.25-8.2z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="m60.38 45.5-8.2 1.25 1.24 8.2 8.2-1.25z" fill={shades.white} strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="m61.81 47.16 1.25 8.2-8.2 1.25-1.43-1.66 8.2-1.25-1.25-8.2z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="m34.74 62.96-8.2 1.25 1.25 8.2 8.2-1.25z" fill={shades.white} strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="m36.18 64.61 1.25 8.2-8.2 1.25-1.44-1.65 8.2-1.25-1.25-8.2z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="m48.57 60.85-8.2 1.25 1.24 8.2 8.2-1.25z" fill={shades.white} strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="m50 62.51 1.25 8.2-8.2 1.25-1.43-1.66 8.2-1.25-1.25-8.19z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M62.4 58.76 54.2 60l1.25 8.2 8.2-1.25z" fill={shades.white} strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="m63.83 60.41 1.24 8.2-8.2 1.24-1.43-1.65 8.2-1.25-1.25-8.2z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="m50.6 74.11-22.03 3.35 1.24 8.2 22.03-3.35z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="m52.02 75.76 1.25 8.2-22.03 3.36-1.43-1.66 22.02-3.35-1.25-8.2z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="m64.4 72-8.2 1.25 1.26 8.2 8.2-1.25z" fill={shades.white} strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="m65.84 73.66 1.25 8.2-8.2 1.25-1.43-1.66 8.2-1.25L64.4 72z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M27.04 75.28c-3.74 4.28-12.39 10.55-15.23 10.6-1.76.05-12.15.04-9.32-10.6 1.22-4.6 4.28-8.25 7.84-10.84-.05 1.84.6 3.42 2.76 3.96 1.5.39 3.82-.7 5.35-1.59a3.2 3.2 0 0 0 1.6-2.83 21 21 0 0 0-.4-3.85c2.25-.51 4.24-.54 5.57-.07 5.08 1.78 5.57 10.94 1.83 15.22Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M32.07 83.23C29.93 94.5 10.5 105.7 4.04 98.64c-4.91-5.4 2.08-15.01 10.57-21.4l.57-.4c-1.6 3.8-1.47 8.63 3.7 8.63 1.3 0 2.68-.64 3.7-1.27a3.7 3.7 0 0 0 1.77-3c.08-2-.04-5.16-1.21-7.1 5.38-.45 10.3 1.94 8.93 9.13Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M20.04 63.98a3.2 3.2 0 0 1-1.6 2.83c-1.53.88-3.85 1.98-5.35 1.6-2.16-.55-2.81-2.14-2.76-3.97a26 26 0 0 1 9.3-4.3c.3 1.34.39 2.76.41 3.85Z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M24.35 81.2a3.7 3.7 0 0 1-1.76 3 7.6 7.6 0 0 1-3.71 1.27c-5.17 0-5.3-4.84-3.7-8.62 2.24-1.5 5.16-2.5 7.95-2.73 1.17 1.93 1.29 5.09 1.22 7.1z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M35.5 100.97c-6.64 11.42-19.76 9.57-21.43 4.35-1.8-5.62 3.14-10.47 6.92-12.95l.76-.48c-.77 2.25-1.54 5.9.93 7.47 2.29 1.47 4.7.42 6.23-.62a2.65 2.65 0 0 0 1.07-2.97c-.47-1.49-1.35-4.38-2.32-6.51 8-2.16 13.14 2.62 7.85 11.7Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M28.9 98.75c-1.52 1.04-3.94 2.09-6.23.62-2.47-1.58-1.7-5.22-.92-7.48a23 23 0 0 1 5.9-2.61c.96 2.13 1.84 5.01 2.3 6.5a2.65 2.65 0 0 1-1.06 2.98z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M80.66 14.06v2.38" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M76.13 10.23H74" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M80.47 6.39V4" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M85 10.2h2.14" strokeWidth={strokeWidth} />
    </svg>
  );
};
